import React from "react";
import { IconLoaderHoc } from ".";

const CustomIcon = (props = {}) => {
  const { disableHoc = false, icon = <IconLoaderHoc /> } = props;
  disableHoc && console.log(icon, disableHoc, JSON.stringify(icon), "icon");
  return <>{icon}</>;
  // // return disableHoc ? React.cloneElement(icon) : React.cloneElement(icon, { ...rest, fill: fill });
};

export default CustomIcon;
